"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAsImageSrc = exports.arrayBufferToBase64 = exports.isWktGeometry = exports.getIconForRedisType = exports.isJsonLikeLongString = exports.safeJsonParse = exports.stringifyCellValue = exports.parseCellValue = exports.hexStringToArray = exports.arrayToHexString = void 0;
const isString_1 = __importDefault(require("lodash/isString"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
function arrayToHexString(byteArray) {
    return byteArray.reduce((output, elem) => output + ('0' + elem.toString(16)).slice(-2), '').toUpperCase();
}
exports.arrayToHexString = arrayToHexString;
function hexStringToArray(inputString) {
    var hex = inputString.toString();
    var res = [];
    for (var n = 0; n < hex.length; n += 2) {
        res.push(parseInt(hex.substr(n, 2), 16));
    }
    return res;
}
exports.hexStringToArray = hexStringToArray;
function parseCellValue(value) {
    if (!(0, isString_1.default)(value))
        return value;
    if (value == '(NULL)')
        return null;
    const mHex = value.match(/^0x([0-9a-fA-F][0-9a-fA-F])+$/);
    if (mHex) {
        return {
            type: 'Buffer',
            data: hexStringToArray(value.substring(2)),
        };
    }
    const mOid = value.match(/^ObjectId\("([0-9a-f]{24})"\)$/);
    if (mOid) {
        return { $oid: mOid[1] };
    }
    return value;
}
exports.parseCellValue = parseCellValue;
function stringifyCellValue(value) {
    if (value === null)
        return '(NULL)';
    if (value === undefined)
        return '(NoField)';
    if ((value === null || value === void 0 ? void 0 : value.type) == 'Buffer' && (0, isArray_1.default)(value.data))
        return '0x' + arrayToHexString(value.data);
    if (value === null || value === void 0 ? void 0 : value.$oid)
        return `ObjectId("${value === null || value === void 0 ? void 0 : value.$oid}")`;
    if ((0, isPlainObject_1.default)(value) || (0, isArray_1.default)(value))
        return JSON.stringify(value);
    return value;
}
exports.stringifyCellValue = stringifyCellValue;
function safeJsonParse(json, defaultValue, logError = false) {
    if ((0, isArray_1.default)(json) || (0, isPlainObject_1.default)(json)) {
        return json;
    }
    try {
        return JSON.parse(json);
    }
    catch (err) {
        if (logError) {
            console.error(`Error parsing JSON value "${json}"`, err);
        }
        return defaultValue;
    }
}
exports.safeJsonParse = safeJsonParse;
function isJsonLikeLongString(value) {
    return (0, isString_1.default)(value) && value.length > 100 && value.match(/^\s*\{.*\}\s*$|^\s*\[.*\]\s*$/);
}
exports.isJsonLikeLongString = isJsonLikeLongString;
function getIconForRedisType(type) {
    switch (type) {
        case 'dir':
            return 'img folder';
        case 'string':
            return 'img type-string';
        case 'hash':
            return 'img type-hash';
        case 'set':
            return 'img type-set';
        case 'list':
            return 'img type-list';
        case 'zset':
            return 'img type-zset';
        case 'stream':
            return 'img type-stream';
        case 'binary':
            return 'img type-binary';
        case 'ReJSON-RL':
            return 'img type-rejson';
        default:
            return null;
    }
}
exports.getIconForRedisType = getIconForRedisType;
function isWktGeometry(s) {
    if (!(0, isString_1.default)(s))
        return false;
    // return !!s.match(/^POINT\s*\(|/)
    return !!s.match(/^POINT\s*\(|^LINESTRING\s*\(|^POLYGON\s*\(|^MULTIPOINT\s*\(|^MULTILINESTRING\s*\(|^MULTIPOLYGON\s*\(|^GEOMCOLLECTION\s*\(|^GEOMETRYCOLLECTION\s*\(/);
}
exports.isWktGeometry = isWktGeometry;
function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = [].slice.call(new Uint8Array(buffer));
    bytes.forEach(b => (binary += String.fromCharCode(b)));
    return btoa(binary);
}
exports.arrayBufferToBase64 = arrayBufferToBase64;
function getAsImageSrc(obj) {
    if ((obj === null || obj === void 0 ? void 0 : obj.type) == 'Buffer' && (0, isArray_1.default)(obj === null || obj === void 0 ? void 0 : obj.data)) {
        return `data:image/png;base64, ${arrayBufferToBase64(obj === null || obj === void 0 ? void 0 : obj.data)}`;
    }
    if ((0, isString_1.default)(obj) && (obj.startsWith('http://') || obj.startsWith('https://'))) {
        return obj;
    }
    return null;
}
exports.getAsImageSrc = getAsImageSrc;
